<template>
  <div class="feature-guide-container"></div>
</template>

<script>
import * as Driver from 'driver.js'
import 'driver.js/dist/driver.min.css'

export default {
  name: 'FeatureGuide',
  props: {
    steps: {
      type: Array,
      required: true,
      validator: (steps) => {
        return steps.every(step => 
          step.element && step.popover && step.popover.title && step.popover.description
        )
      }
    },
    guideKey: {
      type: String,
      required: true
    },
    // 新增：延迟显示时间（毫秒）
    delay: {
      type: Number,
      default: 500
    },
    // 新增：是否强制显示（忽略localStorage记录）
    forceShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      driver: null
    }
  },
  computed: {
    mergedDriverOptions() {
      return {
        className: 'feature-guide-driver',
        animate: true,
        opacity: 0.75,
        padding: 10,
        allowClose: false,
        overlayClickNext: false,
        doneBtnText: '完成',
        closeBtnText: '关闭',
        nextBtnText: '下一步',
        prevBtnText: '上一步',
        onReset: this.onGuideComplete,
        ...this.$attrs
      }
    }
  },
  mounted() {
    this.initDriver()
    this.autoStartGuide()
  },
  methods: {
    initDriver() {
      this.driver = new Driver(this.mergedDriverOptions)
      this.driver.defineSteps(this.steps)
    },
    
    autoStartGuide() {
      // 如果强制显示或未完成引导
      if (this.forceShow || !this.hasCompletedGuide()) {
        // 延迟确保DOM已渲染完成
        setTimeout(() => {
          this.startGuide()
        }, this.delay)
      }
    },
    
    hasCompletedGuide() {
      return localStorage.getItem(`guide_${this.guideKey}`) === 'completed'
    },
    
    startGuide() {
      // 确保目标元素存在
      const allElementsExist = this.steps.every(step => {
        return document.querySelector(step.element)
      })
      
      if (allElementsExist && this.driver) {
        this.driver.start()
      } else {
        console.warn('引导目标元素未找到，引导未启动')
      }
    },
    
    onGuideComplete() {
      localStorage.setItem(`guide_${this.guideKey}`, 'completed')
      this.$emit('complete')
    },
    
    resetGuide() {
      localStorage.removeItem(`guide_${this.guideKey}`)
    }
  }
}
</script>

<style>
.feature-guide-driver .driver-popover {
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.feature-guide-driver .driver-popover-title {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #1890ff 
}

.feature-guide-driver .driver-popover-description {
  font-size: 14px !important;
  line-height: 1.5 !important;
}

.feature-guide-driver .driver-popover-footer {
  margin-top: 12px !important;
  text-align: right !important;
}

.feature-guide-driver .driver-popover-footer button {
  margin-left: 8px !important;
}

.driver-next-btn{
  background-color: #1890ff !important;
  color: #fff !important;
  border: 1px solid #1890ff !important;
  text-shadow: none !important;
}
</style>